<script>

    import MissingData from "./MissingData.svelte";
    import {_} from '../lib/i18n';
    import {navigate} from "svelte-routing";
    import FreeAccessDataHiddenAlert from "./FreeAccessDataHiddenAlert.svelte";

    export let params = {};
    export let date;

    let path = '';
    $: path = (params && params.path) ? params.path : '';

    let progress = 0;
    $: progress = analyze ? (Number(analyze.fansProgress) + Number(analyze.likesProgress)) : 0;

    export let analyze;

    let items = [];
    $: analyze && (items = (analyze.result && analyze.result.fans)  ? analyze.result.fans : []);

    let isTemporary;
    $: isTemporary = (analyze && analyze.temporary ? true : false);

    let isEnabledFreeTrial = false;
    $: isEnabledFreeTrial = params.identity.isEnabledFreeTrial();

    function gotoTariffs() {
        navigate(`${path}/dashboard/subscription`);
    }

    function onImageError(event) {
        event.target.src = '/spy20-lk/icons/avatar-empty.svg';
    }

    function onImageClick() {
        if (isEnabledFreeTrial) gotoTariffs();
    }

    let showCounter = 10;
    let showShowMore = false;
    $: items && (showShowMore = (items.length > showCounter));
    let filteredItems = [];
    function filterItems() {
        filteredItems = [...items];
        filteredItems.sort((a, b) => {
            if ( (a.actions) < (b.actions) ){
                return 1;
            }
            if ( (a.actions) > (b.actions) ){
                return -1;
            }
            return 0;
        });
        filteredItems = filteredItems.splice(0, showCounter);
    }

    function showMore() {
        showCounter += 10;
        if (showCounter > items.length) {
            showCounter = items.length;
            showShowMore = false;
        }
    }

    $: (analyze || items || showCounter) && filterItems();

    let showDescription = !window.localStorage.getItem('hideLikersDescription');

    function hideDescription() {
        showDescription = false;
        window.localStorage.setItem('hideLikersDescription', true);
    }
</script>

{#if !isTemporary}
    {#if showDescription}
        <div class="feed-status__fans system-info">
            <div class="feed-status__fans-title-wrapper system-info__title-wrapper">
                <div class="feed-status__fans-title-icon system-info__title-icon">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.25 14.25V13.5C2.25 11.8431 3.59315 10.5 5.25 10.5H8.25C9.90685 10.5 11.25 11.8431 11.25 13.5V14.25M11.25 8.25C12.4926 8.25 13.5 7.24264 13.5 6C13.5 4.75736 12.4926 3.75 11.25 3.75M15.75 14.25V13.5C15.75 11.8431 14.4069 10.5 12.75 10.5H12.375M9 6C9 7.24264 7.99264 8.25 6.75 8.25C5.50736 8.25 4.5 7.24264 4.5 6C4.5 4.75736 5.50736 3.75 6.75 3.75C7.99264 3.75 9 4.75736 9 6Z" stroke="#57A41B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </div>
                <h3 class="feed-status__fans-title-text system-info__title-text">{$_('likersResult.descriptionTitle')}</h3>
            </div>
            <p class="feed-status__fans-text system-info__text">
                {@html $_('likersResult.description')}
            </p>
            <div class="feed-status__fans-controls-wrapper system-info__controls-wrapper">
                <div class="button button_shadow system-info__controls-btn system-info__controls-btn_main feed-status__fans-btn"
                     on:click={hideDescription}>
                    {$_('likersResult.gotIt')}
                </div>
            </div>
        </div>
    {/if}

    {#if (((window.shared.state.language === 'en-US' && items.length > 0) || window.shared.state.language !== 'en-US') && isEnabledFreeTrial)}
        <FreeAccessDataHiddenAlert {params} />
    {/if}

    {#if items.length > 0}
        {#each filteredItems as item, index}
        <div class="feed-item feed-item_fan">
            <div class="feed-item__header">
                <div class="feed-item__rating">{index + 1}</div>
                <div class="feed-item__header-wrapper">
                    <img src={item.avatar} alt="" class="feed-item__avatar {isEnabledFreeTrial ? 'blur-content' : ''}"
                         on:error={onImageError} on:click={onImageClick}/>
                    <div class="feed-item__info-wrapper">
                        {#if (isEnabledFreeTrial)}
                            <p class="feed-item__name">@{$_('likersResult.someone')}</p>
                        {:else}
                            <a href={`https://instagram.com/${item.username}`} class="feed-item__name" target="_blank">@{item.username}</a>
                        {/if}

                        <div class="feed-item__stats-wrapper">
                            <div class="feed-item__stats-item">
                                <div class="feed-item__stats-label">
                                    <p class="feed-item__stats-title">{$_('likersResult.actionsCountLabel')}</p>
                                </div>
                                {#if (isEnabledFreeTrial)}
                                    <p class="feed-item__stats-number">XXX</p>
                                {:else}
                                    <p class="feed-item__stats-number">{item.actions}</p>
                                {/if}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/each}

        {#if showShowMore}
            <button class="button button_ghost feed-content__load-more-btn" on:click={showMore}>{$_('likersResult.loadMore')}</button>
        {/if}
    {:else}
        <MissingData {analyze} {path} analyzeInProgress={progress != 200} category="likers" />
    {/if}
{/if}

<style>
    .feed-status__fans-title-text {
        color: #161516;
    }
    .system-info__title-icon svg path {
        stroke: #161516;
    }
    .feed-item__avatar {
        border-radius: 100%;
    }
    .blur-content {
        -webkit-filter: blur(10px);
        filter: blur(10px);
        cursor: pointer;
    }
</style>